import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { timeFormat } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";

/** Minutos desde a meia-noite (o servidor guarda o horário como data). */
export const minutos = (horario) => {
  const [h, m] = timeFormat(horario).split(":").map(Number);
  return h * 60 + m;
};

export const porHorarioInicio = (a, b) =>
  minutos(a.horarioInicio) - minutos(b.horarioInicio) || (a.ordemAula ?? 0) - (b.ordemAula ?? 0);

const duracao = (aula) => {
  const total = minutos(aula.horarioFim) - minutos(aula.horarioInicio);
  return total > 0 ? `${total} min` : "--";
};

/** Lista dos horários de aula da instituição. */
export default function CronogramaAulaTable({ cronogramasAula, isLoading, onEdit, onDelete }) {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando horários de aula..." />
      </Box>
    );
  }

  if (cronogramasAula.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <AccessTimeOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum horário de aula cadastrado.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Horários de aula">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell sx={{ width: 90 }} align="center">
              Ordem
            </TableCell>
            <TableCell>Descrição</TableCell>
            <TableCell>Horário</TableCell>
            <TableCell>Duração</TableCell>
            <TableCell align="right" sx={{ width: 96 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {cronogramasAula.map((aula) => (
            <TableRow key={aula.codigo} hover>
              <TableCell align="center">
                <Typography variant="body2" fontWeight={600}>
                  {aula.ordemAula}ª
                </Typography>
              </TableCell>
              <TableCell>{aula.descricao}</TableCell>
              <TableCell>
                {timeFormat(aula.horarioInicio)} - {timeFormat(aula.horarioFim)}
              </TableCell>
              <TableCell sx={{ color: "text.secondary" }}>{duracao(aula)}</TableCell>
              <TableCell align="right">
                <Tooltip title="Editar">
                  <IconButton size="small" onClick={() => onEdit(aula)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                  <IconButton size="small" onClick={() => onDelete(aula)}>
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
